class DateTimeFormatter
{

    private static _instance: DateTimeFormatter;

    formatter: Intl.DateTimeFormat = new Intl.DateTimeFormat('ru');

    public static get Instance() {
        return this._instance || (this._instance = new this());
    }

    asDayWithFullMonth(date: Date): string
    {
        let formatter = new Intl.DateTimeFormat('ru', {
            day: "numeric",
            month: "long",
        });
        return formatter.format(date);
    }

}

export const dateTimeFormatter = DateTimeFormatter.Instance;